// extracted by mini-css-extract-plugin
export var brandCard = "BrandsCarousel-module--brandCard--4fc99";
export var brandCardLink = "BrandsCarousel-module--brandCardLink--30de6";
export var brandName = "BrandsCarousel-module--brandName--a0e7b";
export var brandsCarouselContainer = "BrandsCarousel-module--brandsCarouselContainer--ab859";
export var brandsCarouselItem = "BrandsCarousel-module--brandsCarouselItem--a2d85";
export var brandsCarouselTitle = "BrandsCarousel-module--brandsCarouselTitle--d3ef8";